import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IBlogInitialState } from "./blogModel";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllActiveBlog = createAsyncThunk(
  "Blog/FindAllActiveBlog",
  async () => {
    try {
      const response = await axiosApiInstance.get(`${API_PORTAL_URL}/Blog/FindAllActiveBlog`);
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blog:", error);
      return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
    }
  },
);

export const getBlogByURL = createAsyncThunk(
  "Blog/BlogFindByURL",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(`${API_PORTAL_URL}/Blog/BlogFindByURL`, { BlogURL: URL });
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blog By URL:", error);
      return Promise.reject({ message: error?.response?.data?.Details || "Something went wrong" });
    }
  },
);

const initialState: IBlogInitialState = {
  loading: false, error: "",
  blogDetails: { ID: null, BlogImage: "", BlogTitle: "", BlogDate: "", ShortDescription: "", LongDescription: "", BlogURL: "", MetaTitle: "", MetaDescription: "", Keyword: "", BlogBannerImage: "", BlogFAQList: [] },
  BlogList: [],
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllActiveBlog.pending, (state) => { state.loading = true; });
    builder.addCase(getAllActiveBlog.fulfilled, (state, action) => { state.loading = false; state.BlogList = action.payload || []; state.error = ""; });
    builder.addCase(getAllActiveBlog.rejected, (state, action) => { state.loading = false; state.BlogList = []; state.error = action.error.message || "Something went wrong"; });
    builder.addCase(getBlogByURL.pending, (state) => { state.loading = true; });
    builder.addCase(getBlogByURL.fulfilled, (state, action) => { state.loading = false; state.blogDetails = action.payload || []; state.error = ""; });
    builder.addCase(getBlogByURL.rejected, (state, action) => { state.loading = false; state.blogDetails = initialState.blogDetails; state.error = action.error.message || "Something went wrong"; });
  },
});

export default blogSlice.reducer;
